import { render, staticRenderFns } from "./TenantBankInfoManager.vue?vue&type=template&id=4f04c1f4&"
import script from "./TenantBankInfoManager.vue?vue&type=script&lang=js&"
export * from "./TenantBankInfoManager.vue?vue&type=script&lang=js&"
import style0 from "./TenantBankInfoManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports